<template>
  <div class="toast-body" v-bind:class="`toast-body-${toast.type}`">
    <span class="info-icon" v-bind:class="toast.type"/>
    <p>{{toast.message}}</p>
    <span @click="closeNotification" class="toast-body-close"><i class="fak fa-xmark-regular"></i></span>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tId: null
      }
    },
    name: 'Toast',
    props: {
      toast: { required: true, type: Object}
    },
    methods: {
      closeNotification() {
        this.$store.dispatch('deleteNotification', this.toast.id)
      }
    },
    created() {
      this.tId = setTimeout(() => {
        this.closeNotification()
      }, 5000)
    },
    beforeDestroy() {
      clearTimeout(this.tId)
    }
  }
</script>

<style scoped lang="scss">
  ;
  @keyframes show-message {
    from {
      transform: translateX(-150%);
    }
    to {
      transform: translateX(0);
    }
  }

  .toast-body {
    position: relative;
    width: 340px;
    background-color: white !important;
    box-shadow: 0 1px 2px #d2d6de;
    border-radius: 5px;
    animation: show-message 0.3s 0s 1 forwards;
    padding: 20px 10px;
    display: flex;
    align-items: center;
    word-wrap: break-word;
    gap: 16px;
    p {
      padding-top: 4px;
      padding-bottom: 4px;
      padding-right: 16px;
    }
    .info-icon{
      display: inline-block;
      background-repeat: no-repeat;
      cursor: pointer;
      -webkit-mask-image: url(../../../assets/notification.svg);
      mask-image: url(../../../assets/notification.svg);
      width: 20px;
      height: 20px;
      flex-shrink: 0;
    }
    &-close {
      cursor: pointer;
      padding: 6px;
      color: #9ca1a6;
      position: absolute;
      right: 4px;
      top: 0;
    }
  }
  .toast-body-success {
    border-left: 4px solid #00A65A;
  }
  .toast-body-primary {
    border-left: 4px solid #2889F0;
  }
  .toast-body-warning {
    border-left: 4px solid #FFC107;
  }
  .toast-body-danger {
    border-left: 4px solid #F44444;
  }
</style>